module.exports = __webpack_public_path__ + "static/img/pumpkin_light@2x.39d66af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pumpkin_light@2x.png
// module id = yEQk
// module chunks = 0